import { ChatBubbleIcon, CheckIcon, DotsHorizontalIcon, PieChartIcon } from '@radix-ui/react-icons';
import { Badge, Box, Button, Card, Code, DropdownMenu, Flex, Heading, Marker, Text, Theme } from '@workos-inc/design-system';
import * as React from 'react';
import { flushSync } from 'react-dom';
import { Demo } from './demo';
import { DemoForm } from './demo-form';
export const MfaEnrollmentDemoMultipleMethods = () => <Demo.Root data-sentry-element="Demo.Root" data-sentry-component="MfaEnrollmentDemoMultipleMethods" data-sentry-source-file="mfa-demos.tsx">
    <Demo.Container data-sentry-element="Demo.Container" data-sentry-source-file="mfa-demos.tsx">
      <MfaEnrollmentDemo canEnable={false} data-sentry-element="MfaEnrollmentDemo" data-sentry-source-file="mfa-demos.tsx" />
    </Demo.Container>
  </Demo.Root>;
export const MfaEnrollmentDemoPrimaryMethod = () => <Demo.Root data-sentry-element="Demo.Root" data-sentry-component="MfaEnrollmentDemoPrimaryMethod" data-sentry-source-file="mfa-demos.tsx">
    <Demo.Container data-sentry-element="Demo.Container" data-sentry-source-file="mfa-demos.tsx">
      <MfaEnrollmentDemo canDisable={false} initialMethods={['totp', 'sms']} data-sentry-element="MfaEnrollmentDemo" data-sentry-source-file="mfa-demos.tsx" />
    </Demo.Container>
    <Demo.Caption data-sentry-element="Demo.Caption" data-sentry-source-file="mfa-demos.tsx">
      Try changing the primary method using the dropdown menu on the right.
    </Demo.Caption>
  </Demo.Root>;
export const MfaEnrollmentDemoTotp = () => <Demo.Root data-sentry-element="Demo.Root" data-sentry-component="MfaEnrollmentDemoTotp" data-sentry-source-file="mfa-demos.tsx">
    <Demo.Container data-sentry-element="Demo.Container" data-sentry-source-file="mfa-demos.tsx">
      <ChromeUI data-sentry-element="ChromeUI" data-sentry-source-file="mfa-demos.tsx">
        <ScanQRCode data-sentry-element="ScanQRCode" data-sentry-source-file="mfa-demos.tsx" />
      </ChromeUI>
    </Demo.Container>
  </Demo.Root>;
export const MfaEnrollmentDemoOtpInput = () => {
  const [state, setState] = React.useState<'idle' | 'loading' | 'success'>('idle');
  return <Demo.Root data-sentry-element="Demo.Root" data-sentry-component="MfaEnrollmentDemoOtpInput" data-sentry-source-file="mfa-demos.tsx">
      <Demo.Container data-sentry-element="Demo.Container" data-sentry-source-file="mfa-demos.tsx">
        <ChromeUI data-sentry-element="ChromeUI" data-sentry-source-file="mfa-demos.tsx">
          <DemoForm.Root onSubmit={event => {
          event.persist();
          const form = event.currentTarget;
          setState('loading');
          setTimeout(() => {
            setState('success');
            form.reset();
            setTimeout(() => setState('idle'), 1000);
          }, 1000);
          event.preventDefault();
        }} data-sentry-element="DemoForm.Root" data-sentry-source-file="mfa-demos.tsx">
            <DemoForm.Field mb="3" name="code" data-sentry-element="DemoForm.Field" data-sentry-source-file="mfa-demos.tsx">
              <DemoForm.Label data-sentry-element="DemoForm.Label" data-sentry-source-file="mfa-demos.tsx">One-time-code</DemoForm.Label>
              <OneTimeCodeInput data-sentry-element="OneTimeCodeInput" data-sentry-source-file="mfa-demos.tsx" />
              <OneTimeCodeMessages data-sentry-element="OneTimeCodeMessages" data-sentry-source-file="mfa-demos.tsx" />
            </DemoForm.Field>
            <DemoForm.Submit loading={state === 'loading'} data-sentry-element="DemoForm.Submit" data-sentry-source-file="mfa-demos.tsx">
              {state === 'idle' && 'Verify'}
              {state === 'loading' && 'Verifying…'}
              {state === 'success' && <CheckIcon height="20" width="20" />}
            </DemoForm.Submit>
          </DemoForm.Root>
        </ChromeUI>
      </Demo.Container>
      <Demo.Caption data-sentry-element="Demo.Caption" data-sentry-source-file="mfa-demos.tsx">Try entering a 6 digit code.</Demo.Caption>
    </Demo.Root>;
};
export const MfaEnrollmentDemoFull = () => <Demo.Root data-sentry-element="Demo.Root" data-sentry-component="MfaEnrollmentDemoFull" data-sentry-source-file="mfa-demos.tsx">
    <Demo.Container data-sentry-element="Demo.Container" data-sentry-source-file="mfa-demos.tsx">
      <MfaEnrollmentDemo data-sentry-element="MfaEnrollmentDemo" data-sentry-source-file="mfa-demos.tsx" />
    </Demo.Container>
    <Demo.Caption data-sentry-element="Demo.Caption" data-sentry-source-file="mfa-demos.tsx">Try setting up two-factor authentication.</Demo.Caption>
  </Demo.Root>;
export const MfaSignInDemoSingleMethod = () => <Demo.Root data-sentry-element="Demo.Root" data-sentry-component="MfaSignInDemoSingleMethod" data-sentry-source-file="mfa-demos.tsx">
    <Demo.Container data-sentry-element="Demo.Container" data-sentry-source-file="mfa-demos.tsx">
      <MfaSignInDemo initialMethod="sms" data-sentry-element="MfaSignInDemo" data-sentry-source-file="mfa-demos.tsx" />
    </Demo.Container>
    <Demo.Caption data-sentry-element="Demo.Caption" data-sentry-source-file="mfa-demos.tsx">Try signing in with any credentials.</Demo.Caption>
  </Demo.Root>;
export const MfaSignInDemoMultipleMethods = () => <Demo.Root data-sentry-element="Demo.Root" data-sentry-component="MfaSignInDemoMultipleMethods" data-sentry-source-file="mfa-demos.tsx">
    <Demo.Container data-sentry-element="Demo.Container" data-sentry-source-file="mfa-demos.tsx">
      <MfaSignInDemo canChangeMethod canSignIn={false} initialScreen="verify" data-sentry-element="MfaSignInDemo" data-sentry-source-file="mfa-demos.tsx" />
    </Demo.Container>
    <Demo.Caption data-sentry-element="Demo.Caption" data-sentry-source-file="mfa-demos.tsx">Try changing the verification method.</Demo.Caption>
  </Demo.Root>;
export const MfaSignInDemoFull = () => <Demo.Root data-sentry-element="Demo.Root" data-sentry-component="MfaSignInDemoFull" data-sentry-source-file="mfa-demos.tsx">
    <Demo.Container data-sentry-element="Demo.Container" data-sentry-source-file="mfa-demos.tsx">
      <MfaSignInDemo canChangeMethod data-sentry-element="MfaSignInDemo" data-sentry-source-file="mfa-demos.tsx" />
    </Demo.Container>
    <Demo.Caption data-sentry-element="Demo.Caption" data-sentry-source-file="mfa-demos.tsx">Try signing in with any credentials.</Demo.Caption>
  </Demo.Root>;
type Method = 'sms' | 'totp';
type MfaEnrollmentDemoProps = {
  initialMethods?: Method[];
  canEnable?: boolean;
  canDisable?: boolean;
};
const MfaEnrollmentDemo = ({
  initialMethods = [],
  canEnable = true,
  canDisable = true
}: MfaEnrollmentDemoProps) => {
  const [loading, setLoading] = React.useState(false);
  const [methods, setMethods] = React.useState(initialMethods);
  const [isSettingUpTotp, setIsSettingUpTotp] = React.useState(false);
  const isTotpEnabled = methods.includes('totp');
  const totpDropdownTriggerRef = React.useRef<HTMLButtonElement>(null);
  const [isSettingUpSms, setIsSettingUpSms] = React.useState(false);
  const isSmsEnabled = methods.includes('sms');
  const smsDropdownTriggerRef = React.useRef<HTMLButtonElement>(null);
  const initialPrimaryMethod = isSmsEnabled && isTotpEnabled ? 'totp' : null;
  const [primaryMethod, setPrimaryMethod] = React.useState<Method | null>(initialPrimaryMethod);
  function enableMethod(method: Method) {
    setMethods(prev => [...prev, method]);
    setPrimaryMethod('totp');
  }
  function disableMethod(method: Method) {
    setMethods(prev => prev.filter(m => m !== method));
    setPrimaryMethod(null);
  }
  return <Box style={{
    width: '100%',
    maxWidth: 368,
    backgroundColor: 'var(--color-panel-solid)',
    boxShadow: '0 0 0 1px var(--gray-a3), var(--shadow-4)',
    borderRadius: 'var(--radius-4)',
    overflow: 'hidden'
  }} data-sentry-element="Box" data-sentry-component="MfaEnrollmentDemo" data-sentry-source-file="mfa-demos.tsx">
      <Box p="3" style={{
      backgroundColor: 'var(--gray-a2)',
      boxShadow: 'inset 0 -1px var(--gray-a5)'
    }} data-sentry-element="Box" data-sentry-source-file="mfa-demos.tsx">
        <Text size="2" weight="bold" data-sentry-element="Text" data-sentry-source-file="mfa-demos.tsx">
          Two-factor methods
        </Text>
      </Box>
      <Flex align="center" gap="2" p="3" style={{
      boxShadow: 'inset 0 -1px var(--gray-a5)'
    }} data-sentry-element="Flex" data-sentry-source-file="mfa-demos.tsx">
        <MethodIcon enabled={isTotpEnabled} icon={PieChartIcon} data-sentry-element="MethodIcon" data-sentry-source-file="mfa-demos.tsx" />
        <Text size="2" data-sentry-element="Text" data-sentry-source-file="mfa-demos.tsx">Authenticator app</Text>

        {primaryMethod === 'totp' && <Badge color="purple">Primary</Badge>}

        <Box style={{
        marginLeft: 'auto'
      }} data-sentry-element="Box" data-sentry-source-file="mfa-demos.tsx">
          {isTotpEnabled ? <DropdownMenu.Root>
              <DropdownMenu.Trigger ref={totpDropdownTriggerRef} aria-label="Actions">
                <Button ghost size="1" style={{
              margin: 0
            }}>
                  <DotsHorizontalIcon />
                </Button>
              </DropdownMenu.Trigger>
              <DropdownMenu.Content>
                {primaryMethod !== 'totp' && <DropdownMenu.Item onSelect={() => setPrimaryMethod('totp')}>
                    Set as primary
                  </DropdownMenu.Item>}
                <DropdownMenu.Item disabled={!canDisable} onSelect={() => disableMethod('totp')}>
                  Disable
                </DropdownMenu.Item>
              </DropdownMenu.Content>
            </DropdownMenu.Root> : <Button disabled={!canEnable} size="1" onClick={event => {
          let isSettingUp = isSettingUpTotp;
          flushSync(() => {
            setIsSettingUpTotp(prev => {
              isSettingUp = !prev;
              return isSettingUp;
            });
          });
          const trigger = totpDropdownTriggerRef.current;
          if (!isSettingUp && trigger) {
            event.preventDefault();
            trigger.focus();
          }
        }}>
              {isSettingUpTotp ? 'Cancel' : 'Enable'}
            </Button>}
        </Box>
      </Flex>

      {isSettingUpTotp && <Box pr="3" py="4" style={{
      paddingLeft: 36,
      borderBottom: '1px solid var(--gray-a5)'
    }}>
          <Box mb="4">
            <ScanQRCode />
          </Box>

          <DemoForm.Root onSubmit={event => {
        setLoading(true);
        setTimeout(() => {
          flushSync(() => {
            setLoading(false);
            setIsSettingUpTotp(false);
            enableMethod('totp');
          });
          totpDropdownTriggerRef.current?.focus();
        }, 1000);
        event.preventDefault();
      }}>
            <DemoForm.Field mb="3" name="code">
              <DemoForm.Label>Enter the passcode from your app</DemoForm.Label>
              <OneTimeCodeInput autoFocus disabled={loading} size="2" style={{
            width: 180
          }} />
              <OneTimeCodeMessages />
            </DemoForm.Field>

            <DemoForm.Submit loading={loading} size="2">
              Register
            </DemoForm.Submit>
          </DemoForm.Root>
        </Box>}

      <Flex align="center" gap="2" p="3" style={{
      boxShadow: isSettingUpSms ? 'inset 0 -1px var(--gray-a5)' : undefined
    }} data-sentry-element="Flex" data-sentry-source-file="mfa-demos.tsx">
        <MethodIcon enabled={isSmsEnabled} icon={ChatBubbleIcon} data-sentry-element="MethodIcon" data-sentry-source-file="mfa-demos.tsx" />
        <Text size="2" data-sentry-element="Text" data-sentry-source-file="mfa-demos.tsx">SMS/Text message</Text>

        {primaryMethod === 'sms' && <Badge color="purple">Primary</Badge>}

        <Box style={{
        marginLeft: 'auto'
      }} data-sentry-element="Box" data-sentry-source-file="mfa-demos.tsx">
          {isSmsEnabled ? <DropdownMenu.Root>
              <DropdownMenu.Trigger ref={smsDropdownTriggerRef} aria-label="Actions">
                <Button ghost size="1" style={{
              margin: 0
            }}>
                  <DotsHorizontalIcon />
                </Button>
              </DropdownMenu.Trigger>
              <DropdownMenu.Content>
                {primaryMethod !== 'sms' && <DropdownMenu.Item onSelect={() => setPrimaryMethod('sms')}>
                    Set as primary
                  </DropdownMenu.Item>}
                <DropdownMenu.Item disabled={!canDisable} onSelect={() => disableMethod('sms')}>
                  Disable
                </DropdownMenu.Item>
              </DropdownMenu.Content>
            </DropdownMenu.Root> : <Button disabled={!canEnable} size="1" onClick={event => {
          let isSettingUp = isSettingUpSms;
          flushSync(() => {
            setIsSettingUpSms(prev => {
              isSettingUp = !prev;
              return isSettingUp;
            });
          });
          const trigger = smsDropdownTriggerRef.current;
          if (!isSettingUp && trigger) {
            event.preventDefault();
            trigger.focus();
          }
        }}>
              {isSettingUpSms ? 'Cancel' : 'Enable'}
            </Button>}
        </Box>
      </Flex>

      {isSettingUpSms && <Box pr="3" py="4" style={{
      paddingLeft: 36
    }}>
          <DemoForm.Root onSubmit={event => event.preventDefault()}>
            <DemoForm.Field mb="3" name="phone-number">
              <DemoForm.Label>Enter the number of your device</DemoForm.Label>
              <DemoForm.Input autoFocus required autoComplete="tel" placeholder="+1 234 567 8910" size="2" style={{
            width: 180,
            letterSpacing: '0.05em'
          }} type="tel" />
              <DemoForm.Message match="valueMissing">
                Phone number is required
              </DemoForm.Message>
            </DemoForm.Field>
            <DemoForm.Submit color="gray" mb="5" size="2">
              Send code
            </DemoForm.Submit>
          </DemoForm.Root>

          <DemoForm.Root onSubmit={event => {
        setLoading(true);
        setTimeout(() => {
          flushSync(() => {
            setLoading(false);
            setIsSettingUpSms(false);
            enableMethod('sms');
          });
          smsDropdownTriggerRef.current?.focus();
        }, 1000);
        event.preventDefault();
      }}>
            <DemoForm.Field mb="3" name="code">
              <DemoForm.Label>Enter the passcode you received</DemoForm.Label>
              <OneTimeCodeInput disabled={loading} size="2" style={{
            width: 180
          }} />
              <OneTimeCodeMessages />
            </DemoForm.Field>

            <DemoForm.Submit loading={loading} size="2">
              Register
            </DemoForm.Submit>
          </DemoForm.Root>
        </Box>}
    </Box>;
};
const ScanQRCode = () => <>
    <Heading mb="2" size="2" data-sentry-element="Heading" data-sentry-source-file="mfa-demos.tsx">
      Scan the QR code with the app
    </Heading>
    <Text as="p" mb="3" size="2" data-sentry-element="Text" data-sentry-source-file="mfa-demos.tsx">
      Alternatively, enter the following secret:{' '}
      <Code variant="ghost" data-sentry-element="Code" data-sentry-source-file="mfa-demos.tsx">O5KQ23S3FICSYHSRGJRAWVJVKVYUSYLB</Code>
    </Text>
    <img alt="QR code" aria-describedby="secret-node" height="180" src={qrCode} width="180" style={{
    boxSizing: 'border-box',
    padding: 'var(--space-3)',
    border: '1px solid var(--gray-7)',
    borderRadius: 'var(--radius-3)'
  }} />
  </>;
type MethodIconProps = {
  icon: typeof CheckIcon;
  enabled?: boolean;
};
const MethodIcon = ({
  icon: Icon,
  enabled = false
}: MethodIconProps) => enabled ? <Box width="16px">
      <Text size="2">
        <Marker color="green">
          <CheckIcon />
        </Marker>
      </Text>
    </Box> : <Icon height="16" width="16" />;
const OneTimeCodeInput = React.forwardRef<React.ElementRef<typeof DemoForm.Input>, React.ComponentPropsWithoutRef<typeof DemoForm.Input>>((props, forwardedRef) => <DemoForm.Input ref={forwardedRef} required autoComplete="one-time-code" inputMode="numeric" maxLength={6} pattern="^\d{6}$" placeholder="––––––" onChange={event => {
  if (event.target.value.length === 6) {
    // Introducing lint rule banning type assertions
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const submitButton = event.target.form?.querySelector('button[type="submit"]') as HTMLButtonElement | null;
    submitButton?.click();
  }
}} {...props} style={{
  letterSpacing: '0.25em',
  fontWeight: '600',
  ...props.style
}} />);
OneTimeCodeInput.displayName = 'OneTimeCodeInput';
const OneTimeCodeMessages = () => <>
    <DemoForm.Message match="valueMissing" data-sentry-element="DemoForm.Message" data-sentry-source-file="mfa-demos.tsx">
      One-time-code is required
    </DemoForm.Message>
    <DemoForm.Message match="patternMismatch" data-sentry-element="DemoForm.Message" data-sentry-source-file="mfa-demos.tsx">
      One-time-code needs to be exactly 6 digits.
    </DemoForm.Message>
    <DemoForm.Message match={value => value.match(/^\d{6}$/) === null} data-sentry-element="DemoForm.Message" data-sentry-source-file="mfa-demos.tsx">
      One-time-code needs to be exactly 6 digits.
    </DemoForm.Message>
  </>;
type MfaSignInDemoScreen = 'sign-in' | 'verify' | 'success';
type MfaSignInDemoProps = {
  initialScreen?: MfaSignInDemoScreen;
  initialMethod?: 'sms' | 'totp';
  canChangeMethod?: boolean;
  canSignIn?: boolean;
};
const MfaSignInDemo = (props: MfaSignInDemoProps) => {
  const {
    initialScreen = 'sign-in',
    initialMethod = 'totp',
    canChangeMethod = false,
    canSignIn = true
  } = props;
  const [screen, setScreen] = React.useState<MfaSignInDemoScreen>(initialScreen);
  const [loading, setLoading] = React.useState(false);
  const [method, setMethod] = React.useState<'sms' | 'totp'>(initialMethod);
  if (screen === 'sign-in') {
    return <ChromeUI>
        <DemoForm.Root onSubmit={event => {
        setLoading(true);
        setTimeout(() => {
          setLoading(false);
          setScreen('verify');
        }, 1000);
        event.preventDefault();
      }}>
          <Flex direction="column" gap="5">
            <Heading trim="start">Sign in to Demo App</Heading>
            <DemoForm.Field name="email">
              <DemoForm.Label>Email</DemoForm.Label>
              <DemoForm.Input required placeholder="Enter email address" type="email" />
              <DemoForm.Message match="valueMissing">
                Email is required
              </DemoForm.Message>
              <DemoForm.Message match="typeMismatch">
                Email should be valid.
              </DemoForm.Message>
            </DemoForm.Field>

            <DemoForm.Field name="password">
              <DemoForm.Label>Password</DemoForm.Label>
              <DemoForm.Input required placeholder="Enter password" type="password" />
              <DemoForm.Message match="valueMissing">
                Password is required
              </DemoForm.Message>
            </DemoForm.Field>

            <DemoForm.Submit loading={loading}>Continue</DemoForm.Submit>
          </Flex>
        </DemoForm.Root>
      </ChromeUI>;
  }
  if (screen === 'verify') {
    return <ChromeUI>
        <DemoForm.Root onSubmit={event => {
        setLoading(true);
        setTimeout(() => {
          setLoading(false);
          setScreen('success');
        }, 1000);
        event.preventDefault();
      }}>
          <Flex direction="column" gap="5">
            <Flex direction="column" gap="2">
              <Heading trim="start">Sign in to Demo App</Heading>
              <Text as="p">
                {method === 'totp' && 'Enter the passcode from your authenticator app.'}
                {method === 'sms' && 'Enter the one-time-passcode sent to your device.'}
              </Text>
            </Flex>

            <Flex direction="column" gap="2">
              <DemoForm.Field name="code">
                <DemoForm.Label>One-time-code</DemoForm.Label>
                <OneTimeCodeInput autoFocus />
                <OneTimeCodeMessages />
              </DemoForm.Field>

              {canChangeMethod && <Box>
                  <Button ghost color="purple" type="button" onClick={() => setMethod(prev => prev === 'sms' ? 'totp' : 'sms')}>
                    {method === 'totp' ? 'Send one-time-passcode via SMS' : 'Use passcode from authenticator app'}
                  </Button>
                </Box>}
            </Flex>

            <DemoForm.Submit disabled={!canSignIn} loading={loading}>
              Sign in
            </DemoForm.Submit>
          </Flex>
        </DemoForm.Root>
      </ChromeUI>;
  }
  if (screen === 'success') {
    return <ChromeUI>
        <Flex align="center" direction="column" gap="3" justify="center" minHeight="254px">
          <Heading trim="start">You are signed in</Heading>
          <Button autoFocus size="3" onClick={() => setScreen('sign-in')}>
            Start over
          </Button>
        </Flex>
      </ChromeUI>;
  }
  return null;
};
const ChromeUI = (props: React.ComponentProps<typeof Card>) => <Theme asChild hasBackground={false} panelBackground="solid" data-sentry-element="Theme" data-sentry-component="ChromeUI" data-sentry-source-file="mfa-demos.tsx">
    <Box maxWidth="368px" position="relative" width="100%" data-sentry-element="Box" data-sentry-source-file="mfa-demos.tsx">
      <Box inset="0" m="1" position="absolute" style={{
      borderRadius: 'var(--radius-4)',
      boxShadow: 'var(--shadow-6)'
    }} data-sentry-element="Box" data-sentry-source-file="mfa-demos.tsx" />
      <Card size="3" {...props} data-sentry-element="Card" data-sentry-source-file="mfa-demos.tsx" />
    </Box>
  </Theme>;
const qrCode = 'data:image/png;base64,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';